import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Select } from 'common/react/components/select';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { changeSeason } from 'common/store/modules/competition-nav/thunks';

export const FilterDropdown = ({
    title,
    navItem,
    items,
    icon,
    removeFinals
}) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const selectedId = nav[navItem].id ? Number(nav[navItem].id) : null;

    const itemToString = useCallback((item) => item?.name, []);
    const selectedItemToString = useCallback(
        (item) =>
            navItem === 'season' ? item?.name.split(' ')[0] : item?.name,
        [navItem]
    );
    const initialSelectedItem = useMemo(
        () => (selectedId ? items?.find(({ id }) => id === selectedId) : ''),
        [selectedId, items]
    );
    const activeItem = useMemo(
        () => (selectedId ? items?.find(({ id }) => id === selectedId) : ''),
        [selectedId, items]
    );
    const isReadyToRender = useCallback(
        () => items?.length && selectedId,
        [items, selectedId]
    );
    const onSelectedItemChange = useCallback(
        ({ selectedItem }) => {
            if (navItem === 'season') {
                dispatch(
                    changeSeason({
                        season: selectedItem,
                        removeFinals
                    })
                );
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [navItem]
    );
    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                label={title}
                icon={icon}
                items={items}
                activeItem={activeItem}
                initialSelectedItem={initialSelectedItem}
                itemToString={itemToString}
                isReadyToRender={isReadyToRender}
                selectedItemToString={selectedItemToString}
                onSelectedItemChange={onSelectedItemChange}
                hideLabel
            />
        </div>
    );
};
FilterDropdown.propTypes = {
    items: PropTypes.array,
    title: PropTypes.string,
    navItem: PropTypes.string,
    icon: PropTypes.string,
    removeFinals: PropTypes.bool
};
